import request from '@/request/index.js';
import qs from 'qs';
var UserApi;
(function (UserApi) {
    UserApi["login"] = "/login";
    UserApi["sendMsg"] = "/sendMsg";
    UserApi["getUserPhone"] = "/v1/user/phone";
    UserApi["newLogin"] = "/new/login";
    UserApi["sendVerifyCode"] = "/sendVerifyCode";
    UserApi["delOrder"] = "/delOrder";
    UserApi["newGetUserPhone"] = "/v1/user/userinfo/phone";
    UserApi["newGetPhoneToken"] = "/oppo/token";
})(UserApi || (UserApi = {}));
export const login = (data) => {
    return request.post(UserApi.login, qs.stringify(data));
};
export const newLogin = (data) => {
    return request.post(UserApi.newLogin, qs.stringify(data));
};
export const sendMsg = (data) => {
    return request.post(UserApi.sendMsg, qs.stringify(data));
};
export const getUserPhone = (data) => {
    return request.post(UserApi.getUserPhone, data);
};
export const newGetUserPhone = (data) => {
    return request.post(UserApi.newGetUserPhone, data);
};
export const newGetPhoneToken = (data) => {
    return request.post(UserApi.newGetPhoneToken, qs.stringify(data));
};
export const sendVerifyCode = (params) => {
    return request.get(UserApi.sendVerifyCode, {
        params: params
    });
};
export const delOrder = (data) => {
    return request.post(UserApi.delOrder, qs.stringify(data));
};
